"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpLibraryTabs: {
        gm: 'GreatMinds Library',
        assessments: 'My Assessments',
    },
};
